import React from "react";
import "./EmojiPickerModal.scss";
import "../../../../components/ModalContent/ModalComponents.scss";
import EmojiPicker, { Categories } from "emoji-picker-react";
import { useTranslation } from "react-i18next";

function EmojiPickerModal({ onSelectEmoji }) {
  const { t } = useTranslation();
  // Category headings in the default order, translated
  const categories = [
    { category: Categories.SUGGESTED, name: t("notes.emojiPicker.suggested") },
    {
      category: Categories.SMILEYS_PEOPLE,
      name: t("notes.emojiPicker.smileysPeople"),
    },
    {
      category: Categories.ANIMALS_NATURE,
      name: t("notes.emojiPicker.animalsNature"),
    },
    { category: Categories.FOOD_DRINK, name: t("notes.emojiPicker.foodDrink") },
    {
      category: Categories.TRAVEL_PLACES,
      name: t("notes.emojiPicker.travelPlaces"),
    },
    {
      category: Categories.ACTIVITIES,
      name: t("notes.emojiPicker.activities"),
    },
    { category: Categories.OBJECTS, name: t("notes.emojiPicker.objects") },
    { category: Categories.SYMBOLS, name: t("notes.emojiPicker.symbols") },
    { category: Categories.FLAGS, name: t("notes.emojiPicker.flags") },
  ];
  return (
    <div className="emoji-picker-modal-content">
      <EmojiPicker
        onEmojiClick={(emojiObject) => {
          onSelectEmoji(emojiObject.emoji);
        }}
        width="100%"
        height="400px"
        previewConfig={{
          showPreview: false,
        }}
        searchPlaceholder={t("common.search")}
        searchClearButtonLabel={t("common.clear")}
        categories={categories}
      />
    </div>
  );
}

export default EmojiPickerModal;
